import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {environment} from '@Env/environment';
import {DaoGeneric} from '@Services/base/daoService';
import {HttpClient} from '@angular/common/http';
import {Day, MailBombing, Planning} from './plannig.model';
import {map} from 'rxjs/operators';
import {PlanningHelperService} from './planning-helper-service';
import {Campagne} from "app/suaps/common/services/campagne/campagne.model";

@Injectable({
  providedIn: 'root'
})
export class PlanningService extends DaoGeneric<Planning> {
  readonly url = `${environment.baseUrl}/suaps/planning/`;

  constructor(private httpClient: HttpClient,
              @Inject(LOCALE_ID) private locale: string,
              private planningHelper: PlanningHelperService) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

  getActivityDays(): Day[] {
    return this.planningHelper.getActivityDays();
  }

  getTypeCours(): any {
    return this.planningHelper.getTypeCours();
  }

  getCategorieCours(): any {
    return this.planningHelper.getCategorieCours();
  }

  displayActivityDate(activity: Planning): string {
    return this.planningHelper.displayActivityDate(activity);
  }
  copyPlanning(from: number, to: number) {
    const url = `${this.url}copy_planning/`;
    return this.httpClient.post(url, {from: from, to: to});
  }

  exportPdf(planning: Planning, order: 'date' | 'alpha' | undefined) {
    const url = `${this.url}${planning.id}/export_candidatures/${order}/`;
    return this.httpClient.get(url, {responseType: 'blob'}).pipe(map((data) => new Blob([data])));
  }

  exportXls(planning: Planning) {
    const url = `${this.url}${planning.id}/export_xls_candidatures/`;
    return this.httpClient.get(url, {responseType: 'blob'}).pipe(map((data) => new Blob([data])));
  }

  exportXlsPlannings(campagne: Campagne) {
    const url = `${this.url}export_xls_plannings/${campagne.id}/`;
    return this.httpClient.get(url);
  }

  mailBombing(data: MailBombing) {
    console.log('mailBombing: ', data)
    const url = `${this.url}email_planning/`;
    return this.httpClient.post(url, data);
  }

  mailForSelected(data) {
    console.log('mailForSelected: ', data)
    const url = `${this.url}email_for_selected/`;
    return this.httpClient.post(url, data);
  }

}
